"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnRamper = void 0;
var constants_1 = require("./constants");
var OnRamper = /** @class */ (function () {
    function OnRamper() {
    }
    OnRamper.buy = function (params) {
        if (params === void 0) { params = { supportSell: false }; }
        var url = constants_1.ONRAMP_WIDGET_URL;
        if (Object.keys(params).length) {
            url += '?';
            for (var _i = 0, _a = Object.entries(params); _i < _a.length; _i++) {
                var _b = _a[_i], key = _b[0], value = _b[1];
                url += "".concat(key, "=").concat(value);
            }
        }
        return url;
    };
    return OnRamper;
}());
exports.OnRamper = OnRamper;
